import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface UsernamePasswordValues {
  username?: string;
  password?: string;
}

interface Props<T extends UsernamePasswordValues> {
  disabled?: boolean;
  formik: FormikProps<T>;
  isEditMode: boolean;
}

export const FormikVendorApiUsernamePasswordFields = <
  T extends UsernamePasswordValues,
>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <div className='grid grid-cols-1 gap-x-6 md:grid-cols-2'>
      <FormikTextField
        disabled={props.disabled}
        formik={props.formik}
        label={labelsMsg.username}
        placeholder={props.isEditMode ? '(unchanged)' : undefined}
        name='username'
        type='text'
      />
      <FormikTextField
        disabled={props.disabled}
        formik={props.formik}
        label={labelsMsg.password}
        placeholder={props.isEditMode ? '(unchanged)' : undefined}
        name='password'
        type='password'
      />
    </div>
  );
};
